
import React from "react";
import { useTranslations } from "use-intl";
import PageHeaderActions from "@/components/common/PageHeaderActions";

interface AccountPayablesHeaderProps {
  handleRefreshClick: () => void;
  refreshing: boolean;
}

const AccountPayablesHeader: React.FC<AccountPayablesHeaderProps> = ({
  handleRefreshClick,
  refreshing
}) => {
  const t = useTranslations("consultantPayables.page");
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold tracking-tight pt-2 mb-6">{t("title")}</h1>
      <PageHeaderActions onRefresh={handleRefreshClick} refreshing={refreshing} />
    </div>
  );
};

export default AccountPayablesHeader;
